module.exports = __webpack_public_path__ + "img/european.48377f46.png";